<template>
  <div class="modal__wrap--bg cmp-modal" :class="{'is-active' : annDetailModal}" id="ann-detail-template">
    <div class="modal-wrap-container modal-wd1020">
      <div class="modal-header">
        <h2 class="title">공고 상세 정보</h2>
      </div>
      <div class="modal-body-container">
        <div class="table-wrap mt-0 border-top-none">
          <table class="table-body-only ">
            <caption>공고 정보 테이블</caption>
            <colgroup class="pc-cell">
              <col style="width: 180px;" />
              <col />
            </colgroup>
            <colgroup class="mo-cell">
              <col style="width: 88px;" />
              <col />
            </colgroup>
            <tbody>
              <tr v-if="detail.BIZ_SE !== 'IN49008'">
                <th scope="row">사업연도</th>
                <td>{{ detail.BIZ_YEAR }}</td>
              </tr>
              <tr v-if="detail.BIZ_SE !== 'IN49008'">
                <th scope="row">세부사업명</th>
                <td>{{ detail.BIZNM }}</td>
              </tr>
              <tr>
                <th scope="row">공고명</th>
                <td>{{ detail.ANN_NM }}</td>
              </tr>
              <tr>
                <th scope="row">공고 단계</th>
                <td>{{ detail.ANN_RCRT_STAT_NM }}</td>
              </tr>
              <tr>
                <th scope="row">{{ (annKindType === 'IN' && compYn === 'Y') ? '단계' : '참여자 단계' }}</th>
                <td>
                    <ul class="list" v-if="detail.BIZ_SE !== 'IN49003'">
                      <li>신청·접수 단계 : {{ detail.APP_ING_CD_NM }}<span v-if="detail.APP_DT"> ({{ detail.APP_DT }})</span></li>
                      <li>심사·평가 단계 : {{ detail.JUDGE_ING_CD_NM }}<span v-if="detail.JUDGE_DT"> ({{ detail.JUDGE_DT }})</span></li>
                      <li v-if="annKindType === 'JB' || (annKindType === 'IN' && compYn !== 'Y')">교육 단계 : {{ detail.EDU_ING_CD_NM }}<span v-if="detail.EDUDRNG_ST && detail.EDUDRNG_ED"> ({{ detail.EDUDRNG_ST }}~{{ detail.EDUDRNG_ED }})</span></li>
                      <li v-if="annKindType === 'JB' || (annKindType === 'IN' && compYn !== 'Y')">활동 단계 : {{ detail.ACT_ING_CD_NM }}<span v-if="detail.ACTPER_ST && detail.ACTPER_ED"> ({{ detail.ACTPER_ST }}~{{ detail.ACTPER_ED }})</span></li>
                    </ul>
                    <ul class="list" v-if="detail.BIZ_SE === 'IN49003'">
                      <li>신청·접수 단계 : {{ detail.APP_ING_CD_NM }}<span v-if="detail.APP_DT"> ({{ detail.APP_DT }})</span></li>
                      <li v-if="detail.EDU_ING_STEP">참여 단계 : 참여완료</li>
                   </ul>
                </td>
              </tr>
              <tr>
                <th scope="row">신청정보 조회</th>
                <td><button type="button" class="btn btn-gray btn-sm wid88" @click="showAppViewModal">조회</button></td>
              </tr>
              <tr v-if="annKindType === 'JB' || (annKindType === 'IN' && compYn !== 'Y' && detail.BIZ_SE !== 'IN49008') ">
                <th scope="row">중도포기</th>
                <td v-if="annKindType =='JB' && detail.SEQ == null && detail.CUR_STAT_CD != 'JB22001'">
                  <button type="button" class="btn btn-gray btn-sm wid88" @click="showGiveUpRegistModal">포기</button>
                </td>
                <td v-else-if="annKindType =='IN' && detail.SEQ == null && (detail.CUR_STAT_CD == 'IN22002' || detail.CUR_STAT_CD == 'IN22003' || detail.CUR_STAT_CD == 'IN22004')">
                  <button type="button" class="btn btn-gray btn-sm wid88" @click="showGiveUpRegistModal">포기</button>
                </td>
                <td v-else>{{ detail.GIVEUP_CD_NM }}</td>
              </tr>
              <tr v-if="annKindType === 'JB' || (annKindType === 'IN' && compYn !== 'Y')">
                <th scope="row">활동 확인서</th>
                <td><button type="button" class="btn btn-gray btn-sm wid88" v-if="detail.PRINT_CHK == 'P'" @click="actJnlReport">출력</button></td>
              </tr>
              <!-- <tr v-if="false">
                <th scope="row">설문조사</th>
                <td><button type="button" class="btn btn-gray btn-sm wid88" v-if="detail.SURVEY_NO > 0" @click="showPollRgstModal">참여하기</button></td>
              </tr> -->
              <tr>
                <th scope="row">취소 신청</th>
                <td v-if="annKindType =='JB' && detail.CUR_STAT_CD == 'JB22001' && detail.APP_ING_CD == 'JB21002' && detail.ANN_RCRT_STAT == 'JB17003'">
                  <button type="button" class="btn btn-gray btn-sm wid88" @click="appCancle">신청 취소</button>
                </td>
                <td v-else-if="annKindType =='IN' && (detail.CUR_STAT_CD == 'IN22001' || detail.CUR_STAT_CD == 'IN42001') && (detail.APP_ING_CD == 'IN21001' || detail.APP_ING_CD == 'IN21002')">
                  <button type="button" class="btn btn-gray btn-sm wid88" @click="appCancle">신청 취소</button>
                </td>
                <td v-else></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-md button-wid150 close-modal" @click="close">
          닫기
        </button>
        <button type="button" class="btn btn-primary btn-md button-wid150" @click="goToAnnDetail">
          공고 바로가기
        </button>
      </div>
      <button type="button" class="btn btn-close only-icon close-modal" aria-label="닫기" @click="close" title="닫기">
        <i class="ico ico-x-bl"></i>
      </button>
    </div>
    <app-view-modal :appViewModal="appViewModal" :annKindType="annKindType" :appNo="detail.APP_NO" :annNo="detail.ANN_NO" @update:appViewModal="appViewModal = $event" :bizSe="detail.BIZ_SE"></app-view-modal>
    <giveup-regist-modal  :detail="detail" :annKindType="annKindType" :giveUpRegistModal="giveUpRegistModal" @update:giveUpRegistModal="giveUpRegistModal = $event"></giveup-regist-modal>
  </div>
</template>

<script>
import Axios from 'axios';
import AppViewModal from './AppView.vue';
import GiveupRegistModal from './GiveUpRegist.vue';

export default {
  name: 'ann-detail-template',
  props: ['annDetailModal', 'annNo', 'appNo', 'annKindType'],
  components: {
    AppViewModal,
    GiveupRegistModal,
  },
  data() {
    return {
      detail: {
        SEQ: '',
        ANN_NO: 0,
        APP_NO: 0,
        BIZNM: '',
        BIZ_YEAR: '',
        BIZ_SE: '',
        ANN_NM: '',
        SURVEY_NO: 0,
        CUR_STAT_CD: '',
        CUR_STAT_CD_NM: '',
        ANN_RCRT_STAT: '',
        ANN_RCRT_STAT_NM: '',
        APP_ING_CD: '',
        APP_ING_CD_NM: '',
        JUDGE_ING_STEP: '',
        JUDGE_ING_CD_NM: '',
        EDU_ING_STEP: '',
        EDU_ING_CD_NM: '',
        ACT_ING_STEP: '',
        ACT_ING_CD_NM: '',
        APPDURNG_ST: '',
        APPDURNG_ED: '',
        APP_DT: '',
        JUDGE_DT: '',
        EDUDRNG_ST: '',
        EDUDRNG_ED: '',
        ACTPER_ST: '',
        ACTPER_ED: '',
        GIVEUP_CD_NM: '',
        PRINT_CHK: '',
      },
      compYn: '',
      appViewModal: false,
      giveUpRegistModal: false,
    };
  },
  watch: {
    annDetailModal: {
      handler(newVal) {
        if (newVal) this.getDetail();
      },
    },
    giveUpRegistModal: {
      handler(newVal, oldVal) {
        if (!newVal && oldVal) this.getDetail();
      },
    },
  },
  methods: {
    initializeData() {
      this.detail = {
        SEQ: 0,
        ANN_NO: 0,
        APP_NO: 0,
        BIZNM: '',
        BIZ_YEAR: '',
        ANN_NM: '',
        SURVEY_NO: 0,
        CUR_STAT_CD: '',
        CUR_STAT_CD_NM: '',
        ANN_RCRT_STAT: '',
        ANN_RCRT_STAT_NM: '',
        APP_ING_CD: '',
        APP_ING_CD_NM: '',
        JUDGE_ING_STEP: '',
        JUDGE_ING_CD_NM: '',
        EDU_ING_STEP: '',
        EDU_ING_CD_NM: '',
        ACT_ING_STEP: '',
        ACT_ING_CD_NM: '',
        APPDURNG_ST: '',
        APPDURNG_ED: '',
        APP_DT: '',
        JUDGE_DT: '',
        EDUDRNG_ST: '',
        EDUDRNG_ED: '',
        ACTPER_ST: '',
        ACTPER_ED: '',
        GIVEUP_CD_NM: '',
        PRINT_CHK: '',
      };
      this.compYn = '';
      this.appViewModal = false;
      this.giveUpRegistModal = false;
    },
    getDetail() {
      const url = (this.annKindType === 'JB') ? '/api/app/detail' : '/api/in_app/detail';
      Axios.get(url, { params: { ANN_NO: this.annNo, APP_NO: this.appNo } }).then((response) => {
        this.detail = response.data.data.detail;
        // IN에서만 compYn 처리
        if (this.annKindType === 'IN') {
          console.log('compYn 값:', response.data.data.compYn);
          this.compYn = response.data.data.compYn;
        }
      }).catch((e) => {
        alert(e.response.data.message);
      });
    },
    showAppViewModal() {
      this.appViewModal = true;
    },
    showGiveUpRegistModal() {
      this.giveUpRegistModal = true;
    },
    showPollRgstModal() {
      // 퍼블 확인 필요
      // 작업시 src\main\webapp\WEB-INF\jsp\mypage\JB\app\surJoin.jsp 참조
    },
    actJnlReport() {
      const url = (this.annKindType === 'JB') ? `https://rpt.50plus.or.kr/actJnlReport.do?APP_NO=${this.appNo}` : `https://rpt.50plus.or.kr/in_actJnlReport.do?APP_NO=${this.appNo}`;
      // const url = (this.annKindType === 'JB') ? `/actJnlReport.do?APP_NO=${this.appNo}` : `/in_actJnlReport.do?APP_NO=${this.appNo}`;
      window.open(url, 'PopupWin', 'width=1200,height=900');
    },
    appCancle() {
      if (this.detail.BIZ_SE === 'IN49003') {
        const today = new Date().toISOString().slice(0, 10);
        if (today > this.detail.APPDURNG_ED) {
          alert('신청기간이 종료되어 취소할 수 없습니다.');
          return;
        }
      }
      if (confirm('50+ 일자리 신청서를 취소하시겠습니까?')) {
        const url = (this.annKindType === 'JB') ? '/appCancleAjax.do' : '/in_appCancleAjax.do';
        const params = {
          APP_NO: this.detail.APP_NO,
          PRE_STAT: this.detail.CUR_STAT_CD,
        };
        $.ajax({
          url: url,
          type: 'GET',
          data: params,
          success: (response) => {
            console.log('신청취소 응답:', response);
            console.log('success 값:', response.success);

            if (response.success === "M") {
              alert(response.msg);
              this.getDetail();
              this.close();
              this.$emit('refresh');
            } else if (response.success === "E") {
              alert(response.msg || response.message || '처리 중 오류가 발생했습니다.');
            }
          },
          error: (xhr, status, error) => {
            console.log('신청 취소 요청 실패:', xhr.responseJSON || xhr.responseText);
            alert((xhr.responseJSON && xhr.responseJSON.message) || '요청 처리 중 오류가 발생했습니다.');
          }
        });
      }
    },
    goToAnnDetail() {
      const url = (this.annKindType === 'JB')
        ? `/appView.do?ANN_NO=${this.detail.ANN_NO}`
        : `/in_appView.do?ANN_NO=${this.detail.ANN_NO}`;
      window.location.href = url;
    },
    close() {
      this.$emit('update:annDetailModal', false);
    },
  },
  mounted() {
  },
};
</script>



// WEBPACK FOOTER //
// AnnDetail.vue?268beeb2